export default __webpack_public_path__ + "static/media/venus_symbol.40b7be8b.png";